export const isCreditType = (creditType?: string | null): boolean => {
  return ['regulated credit', 'unregulated credit'].includes(creditType ?? '');
};
